import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  displayValue?: string;
  heightValue?: string;
};

export const Root = styled.div`
  display: ${(props: IRootProps) => (props.displayValue ?? 'auto')};
  position: absolute;
  width: calc(100% - 92px);
  height: ${(props: IRootProps) => props.heightValue ? props.heightValue : 'auto'};
  bottom: 0px;
  left: 0px;
  margin: 0px 46px 0px 46px;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
  background-color: ${C.WHITE};
  overflow-y: scroll;
  transition: height 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
